import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type TipoRicerca = 'pagine' | 'giornali' | 'pubblicazioni-tematiche';
export type TipoVisualizzazione = 'singola-pagina' | 'edizione';

export interface SearchState {
  searchTerm: string;
  tipo: TipoRicerca;
  tipoVisualizzazione?: TipoVisualizzazione;
  tema?: string | null;
}
export interface DetailState {
  nomeTestata: string;
  detail: [];
  tipo: TipoRicerca;
  tipoVisualizzazione?: TipoVisualizzazione;
}

@Injectable({
  providedIn: 'root',
})
export class SearchStateService {
  private state$ = new BehaviorSubject<SearchState>({
    searchTerm: '',
    tipo: 'pagine',
    tipoVisualizzazione: 'singola-pagina',

  });

  private detailState$ = new BehaviorSubject<DetailState>({
    nomeTestata: '',
    detail: [],
    tipo: 'pagine',
    tipoVisualizzazione: 'singola-pagina',

  });

  getState(): SearchState {
    return this.state$.value;
  }

  getDetailState(): DetailState {
    return this.detailState$.value;
  }

  resetState() {
    this.state$.next({
      searchTerm: '',
      tipo: 'pagine',
    });
  }

  resetDetailState() {
    this.detailState$.next({
      nomeTestata: '',
      detail: [],
      tipo: 'pagine',
    });
  }

  setSearchTerm(term: string) {
    const state = this.state$.value;
    this.state$.next({ ...state, searchTerm: term });
  }

  setTipo(tipo: TipoRicerca) {
    const state = this.state$.value;
    this.state$.next({ ...state, tipo });
  }

  setTipoVisualizzazione(tipoVisualizzazione: TipoVisualizzazione) {
    const state = this.state$.value;
    this.state$.next({ ...state, tipoVisualizzazione });
  }

  setState(partial: Partial<SearchState>) {
    const state = this.state$.value;
    this.state$.next({ ...state, ...partial });
  }

  setDetailState(partial: Partial<DetailState>) {
    const state = this.detailState$.value;
    this.detailState$.next({ ...state, ...partial });
  }
}
